module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-navy-1-0d62831b34623608e4c14aea8ebf01e9.png";